import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueMoment from 'vue-moment'
import InlineSvg from 'vue-inline-svg'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './services/i18n/i18n'
import { genericMixins } from '@/utilities/mixins'
import VueAutosuggest from 'vue-autosuggest'

import BaseButton from './components/UI/BaseButton.vue'
import BaseInput from './components/UI/BaseInput.vue'
import BaseSelect from './components/UI/BaseSelect.vue'
import BasePagination from './components/UI/BasePagination.vue'
import BaseSpinner from './components/UI/BaseSpinner.vue'
import BaseCheckbox from './components/UI/BaseCheckbox.vue'
import BaseDatePicker from './components/UI/BaseDatePicker.vue'
import BaseDateRangePicker from './components/UI/BaseDateRangePicker.vue'
import BaseDateTimePicker from './components/UI/BaseDateTimePicker.vue'
import BaseImagePicker from './components/UI/BaseImagePicker.vue'
import BaseTimePicker from './components/UI/BaseTimePicker.vue'
import BaseToast from '@/components/UI/BaseToast.vue'
import BaseTextarea from '@/components/UI/BaseTextarea.vue'
import Multiselect from 'vue-multiselect'
import BaseTimePickerHijri from '@/components/UI/BaseTimePickerHijri.vue'
import AlphaNumericNoSpaceInput from '@/components/UI/alphaNumericNoSpaceInput'
import BaseBreadcrumb from '@/components/UI/BaseBreadcrumb.vue'
import BaseMultiSelect from '@/components/UI/BaseMultiSelect.vue'
import BaseTable from '@/components/UI/BaseTable.vue'
import BaseAlert from '@/components/UI/BaseAlert.vue'
import BaseGenerateQr from '@/components/UI/BaseGenerateQr.vue'
import BaseInlineAlert from '@/components/UI/BaseInlineAlert.vue'
import BaseCardInfo from '@/components/UI/BaseCardInfo.vue'
import BaseSwitcher from '@/components/UI/BaseSwitcher.vue'
import BaseCheckboxButtons from '@/components/UI/BaseCheckboxButtons.vue'
import BaseGeneralInfo from '@/components/UI/BaseGeneralInfo.vue'
import APIService from './services/api/index'
import BaseUploadFile from './components/UI/BaseUploadFile.vue'
import BaseSelectWithBox from './components/UI/BaseSelectWithBox.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '@/services/vee-validate'
import JwtUtilService from '@/services/jwt.util.service'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import config from '@/config'

Vue.prototype.$config = config
Vue.use(BootstrapVue)
Vue.use(VueMoment)
Vue.mixin({
  ...genericMixins,
})
Vue.use(VueAutosuggest)
Vue.component('inline-svg', InlineSvg)
Vue.component('validation-observer', ValidationObserver)
Vue.component('validation-provider', ValidationProvider)
Vue.component('base-button', BaseButton)
Vue.component('base-input', BaseInput)
Vue.component('base-select', BaseSelect)
Vue.component('base-pagination', BasePagination)
Vue.component('base-spinner', BaseSpinner)
Vue.component('base-checkbox', BaseCheckbox)
Vue.component('base-date-picker', BaseDatePicker)
Vue.component('base-date-range-picker', BaseDateRangePicker)
Vue.component('base-date-time-picker', BaseDateTimePicker)
Vue.component('base-image-picker', BaseImagePicker)
Vue.component('base-toast', BaseToast)
Vue.component('base-time-picker', BaseTimePicker)
Vue.component('base-textarea', BaseTextarea)
Vue.component('multi-select', Multiselect)
Vue.component('base-breadcrumb', BaseBreadcrumb)
Vue.component('base-multi-select', BaseMultiSelect)
Vue.component('base-date-picker-hijri', BaseTimePickerHijri)
Vue.component('alphanumeric-no-space-input', AlphaNumericNoSpaceInput)
Vue.component('base-table', BaseTable)
Vue.component('base-alert', BaseAlert)
Vue.component('base-generate-qr', BaseGenerateQr)
Vue.component('base-inline-alert', BaseInlineAlert)
Vue.component('base-card-info', BaseCardInfo)
Vue.component('base-switcher', BaseSwitcher)
Vue.component('base-checkbox-buttons', BaseCheckboxButtons)
Vue.component('base-general-info', BaseGeneralInfo)
Vue.component('base-upload-file', BaseUploadFile)
Vue.component('base-select-with-box', BaseSelectWithBox)
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
})

Vue.filter('camelcase', (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
})

new APIService()

if (window.location.hostname !== 'localhost')
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_URL,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: process.env.VUE_APP_ENVIRONMENT,
  })

const params = new URLSearchParams(window.location.search)
const token = params.get('token')

if (token) {
  localStorage.setItem('access_token', token)
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
